import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import {
  ARCHIVE_MOCK,
  MERGE_MOCK,
  CATEGORIZE_MOCK,
} from '../pages/Accounting/ChartOfAccounts/cleanup-review/mockData';

function loadIdsCount(key: string): number {
  try {
    const raw = window.localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as string[]).length : 0;
  } catch {
    return 0;
  }
}

export interface VelaCleanupCounts {
  archive: number;
  merge: number;
  categorize: number;
  total: number;
}

export function useVelaCleanupCounts(): VelaCleanupCounts {
  const location = useLocation();

  return useMemo(() => {
    const params = new URLSearchParams(location.search);
    const emptyFlag = params.get('empty') === '1';

    if (emptyFlag) {
      return { archive: 0, merge: 0, categorize: 0, total: 0 };
    }

    const archiveApproved = loadIdsCount('novala.archivedAccounts');
    const archiveDismissed = loadIdsCount('novala.archiveDismissed');
    const archive = Math.max(0, ARCHIVE_MOCK.length - archiveApproved - archiveDismissed);

    const mergeApproved = loadIdsCount('novala.mergedPairs');
    const mergeDismissed = loadIdsCount('novala.dismissedPairs');
    const merge = Math.max(0, MERGE_MOCK.length - mergeApproved - mergeDismissed);

    const categorizeApproved = loadIdsCount('novala.approvedCategorize');
    const categorizeDismissed = loadIdsCount('novala.dismissedCategorize');
    const categorize = Math.max(0, CATEGORIZE_MOCK.length - categorizeApproved - categorizeDismissed);

    return { archive, merge, categorize, total: archive + merge + categorize };
  }, [location.search]);
}